import React from 'react';

import { useGetList } from '@vlabs/api/luna-api/client';
import type { ListId } from '@vlabs/api/luna-api/model';
import { PageHeader } from '@vlabs/monokit/shared/ui/page';
import { Breadcrumbs, Breadcrumb } from '@vlabs/uikit';
import { routes } from '@vlapps/point/src/app/routes';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import { ListCardsActions } from './ListCardsActions';
import { ListFacesActions } from './ListFacesActions';
import { useListTypeContext } from '../../ListTypeContext';

interface ListDetailsPageHeaderProps {
  listId: ListId;
}

export function ListDetailsPageHeader({ listId }: ListDetailsPageHeaderProps): React.JSX.Element {
  const { t } = useTranslation();
  const { listType } = useListTypeContext();
  const getList = useGetList(listId);
  return (
    <PageHeader
      actions={(
        <React.Fragment>
          {listType === 'cards' && <ListCardsActions />}
          {listType === 'faces' && <ListFacesActions />}
        </React.Fragment>
      )}
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('face-page:header.breadcrumbs.cards_and_lists')}
            href={generatePath(routes.cardsAndLists.activeTab, { activeTab: 'lists' })}
          />
          <Breadcrumb caption={t('list')} />
        </Breadcrumbs>
)}
      title={getList.data?.user_data ?? '-'}
    />
  );
}
